import {Avatar, Box, Typography} from '@mui/material';
import {useTranslation} from 'next-i18next';
import {useResponsive} from '../../provider/MediaQueryProvider';
import {AuthorOverview, Theme} from '../../types';
import {CampaignNetwork} from '../../types/models/CampaignNetwork';
import {Colors} from '../common/colors';
import NetworkLink from '../network/network';

type SocialProps = {
    networks: CampaignNetwork[];
    author: AuthorOverview;
    theme: Theme;
};

export default function Social(props: SocialProps) {
    const {t} = useTranslation('common');
    const {isMobile, isTablet} = useResponsive();
    const authorPicture = props.author.picture_url;
    const flexDirection = isTablet || isMobile ? 'column' : 'row';
    const margin = isTablet || isMobile ? '15px' : '0px';

    return (
        <Box
            display="flex"
            flexDirection={flexDirection}
            justifyContent="space-between"
            alignItems="center"
            marginTop={isTablet || isMobile ? '25px' : '50px'}
            marginBottom={isTablet || isMobile ? '50px' : '100px'}
        >
            <Box display="flex" flexDirection="row">
                <Avatar
                    alt={props.author.display_name}
                    src={authorPicture}
                    imgProps={{referrerPolicy: 'no-referrer'}}
                    sx={{width: 50, height: 50}}
                />
                <Box marginLeft="20px">
                    <Typography>{t('field.carrier')}</Typography>
                    <Typography fontWeight="bold" fontSize="16px">
                        {props.author.display_name}
                    </Typography>
                </Box>
            </Box>
            <Box display="flex" flexDirection={flexDirection}>
                {props.networks.length > 0 && (
                    <>
                        <Typography
                            color={props.theme?.background_color ?? Colors.first}
                            textTransform="uppercase"
                            marginRight={isTablet || isMobile ? '0px' : '40px'}
                            marginTop={margin}
                            marginBottom={margin}
                            alignSelf="center"
                            fontWeight="bold"
                            fontSize="18px"
                        >
                            {t('tips.network')}
                        </Typography>
                        <Box display="flex" flexDirection={'row'} justifyContent="center">
                            {props.networks.map((n, i) => (
                                <NetworkLink network={n.network} url={n.url} key={n.network} />
                            ))}
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
}
